import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';


@Component({
    selector: 'app-passorder-dialog',
    templateUrl: './passorder-dialog.component.html',
    styleUrls: ['./passorder-dialog.component.scss'],
    standalone: false
})
export class PassorderDialogComponent {
	@BlockUI() blockUI: NgBlockUI;
	qrCodeUrl: string = null;
    supportsSharing = false;

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<PassorderDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.qrCodeUrl = this.data.link.directUrl;
		if ('share' in navigator) {
			this.supportsSharing = true;
		} else {
			this.supportsSharing = true;
			console.log('provide fallback share');
		}
	}

	formModel: any = {}

	passByPhone(form) {
		if (!form.valid) return;
		this.blockUI.start();
		let params = this.appService.urlParams;
		this.entityService.post(`/online-shopper/orders/${params.oid}/share`, this.formModel, { 'ros-organization': params.site }).then(res => {
			this.appService.toastr('PASS_ORDER_SENT_SUCCESS', { type: 'success' });
			this.dialogRef.close();
		}).catch(err => {
			this.appService.toastr('CANNOT_SEND_ORDER_BY_SMS', { type: 'error' });
		}).then(ret => {
			this.blockUI.stop();
		});
	}

	cancel() {
		this.dialogRef.close();
	}

}
